/*
 * rheincool — Unternehmensseiten (Unternehmensseiten-Handoff)
 * - Referenz-Filter-Pills (radiogroup, Pfeiltasten) mit Ergebniszahl
 * - Tracking: reference_filter, job_expand
 */
(() => {
  'use strict';
  if (window.__rcCompanyPages) return;
  window.__rcCompanyPages = true;

  const track = (event, params) => {
    if (window.rcTrack) window.rcTrack(event, params || {});
  };

  const filter = document.querySelector('[data-refs-filter]');
  if (filter) {
    const pills = Array.from(filter.querySelectorAll('[data-refs-cat]'));
    const items = Array.from(document.querySelectorAll('[data-refs-item]'));
    const countEl = document.querySelector('[data-refs-count]');
    const apply = (cat) => {
      let shown = 0;
      items.forEach((item) => {
        const hit = cat === 'alle' || item.dataset.refsItem === cat;
        item.hidden = !hit;
        if (hit) shown += 1;
      });
      if (countEl) countEl.textContent = `${shown} ${countEl.dataset.label || 'Projekte'}`;
    };
    pills.forEach((pill, idx) => {
      pill.addEventListener('click', () => {
        pills.forEach((p) => {
          p.classList.toggle('is-selected', p === pill);
          p.setAttribute('aria-checked', p === pill ? 'true' : 'false');
        });
        apply(pill.dataset.refsCat);
        track('reference_filter', { kategorie: pill.dataset.refsCat });
      });
      pill.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') (pills[idx + 1] || pills[0]).focus();
        if (e.key === 'ArrowLeft') (pills[idx - 1] || pills[pills.length - 1]).focus();
      });
    });
    apply('alle');
  }

  document.querySelectorAll('[data-rc-track-job]').forEach((card) => {
    card.addEventListener('toggle', () => {
      if (card.open) track('job_expand', { stelle: card.dataset.rcTrackJob });
    });
  });
})();
